import {KeysMap} from './components/chart/types';
import {compactDateFormatter} from '@epic-visualizations/charts';
import {Data, getDefaultHeaders} from '../../../../utils/CSVUtils';
import {GameXpDataItem} from '../../../../reducers/fortnite-game/gameXp.reducer';

const TIME_KEY = 'time';

export const prepareLineChartExportData = (
    keysMap: KeysMap,
    dateFormatter = compactDateFormatter()
) => (data: Data) => {
    const defaultHeaders = getDefaultHeaders(data).filter(({key}) => key !== TIME_KEY);
    const headers = [{key: TIME_KEY, label: ''}, ...defaultHeaders];
    const dataItemWithTitles = headers.reduce((dataItemWithTitles, {label, key}) => {
        dataItemWithTitles[key] = keysMap[key];
        return dataItemWithTitles;
    }, {});
    const preparedData = data.map(({time, ...rest}) => ({
        ...(time && {time: dateFormatter(String(time))}),
        ...rest
    }));

    return [[dataItemWithTitles, ...preparedData], headers];
};

const GAME_NAME_KEY = 'name';

export const prepareLifetimePlaysExportData = (
    keysMap: KeysMap,
    formatOrdinal: (value: number | string) => string
) => (data: Data) => {
    const headers = data.reduce(
        (headers, {creativeIslandCode}, index) => {
            headers.push({label: formatOrdinal(index + 1), key: String(creativeIslandCode)});
            return headers;
        },
        [
            {label: ' ', key: 'creativeIslandCode'},
            {label: '   ', key: GAME_NAME_KEY}
        ]
    );

    const preparedData = data.map(item =>
        headers.reduce((dataItem, {label, key}) => {
            dataItem[key] =
                key === GAME_NAME_KEY ? String(keysMap[item.creativeIslandCode]) : item[key];
            return dataItem;
        }, {})
    );

    return [preparedData, headers];
};

export const prepareActivationsExportData = () => (data: GameXpDataItem) => {
    const {calibration, activations} = data;

    const activationHeaders = Object.keys(activations[0]);
    const headers = ['calibration', ...activationHeaders.slice(0, -1)].map(header => ({
        key: header,
        label: header
    }));

    return [[{calibration}, ...activations], headers];
};
